<template>
  <div class="graph">
    <!--<chart :options="options"></chart>-->
    <div id="graph" style="width: 100%; height:300px;"></div>
  </div>
</template>

<script>
  import echarts from 'echarts/lib/echarts';
  import Chart from 'vue-echarts/components/ECharts'
  import 'echarts/lib/chart/bar';
  import 'echarts/lib/chart/line';
  import 'echarts/lib/component/title';
  import 'echarts/lib/component/legend';
  import 'echarts/lib/component/toolbox';
  import 'echarts/lib/component/markPoint';
  import 'echarts/lib/component/tooltip';
  import 'echarts/lib/component/dataZoom';

  import { mapGetters } from 'vuex'
  import {getMeasureUnitByCcd, getMeasureWeightByCcd} from "../../../../data/getters";

  export default {
    name: 'watch-graph',
    props: {
      type: {
        default: 'watch'
      },
      selected: {
        default: null
      },
      range: {
        default: null
      }
    },
    data() {
      return {
        // checkedMeasures: {},
        graphData: {},
        chart: null,
        height: 600,
        width: 800,
        emptyOption: {
          color: ['#5793f3', '#675bba', '#d14a61'],
          title: {
            text: 'Measurements'
          },
          tooltip: {
            trigger: 'axis'
          },
          // attributes on hover over
          legend: {
            data: ['point'],
          },
          grid: {
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              dataView: {readOnly: false},
              magicType: {type: ['bar', 'line']},
              restore: {},
            }
          },
          // array of dates
          xAxis: {
            data: []
          },
          yAxis: {
            axisLabel: {show: true}
          },
          series: [
            {
              data: [],
              type: 'line'
            },
          ]
        }
      }
    },
    components: {
      Chart
    },
    updated() {
      if(this.chart)
      {
        this.chart.dispose();
        delete this.chart;
        this.chart = null;
      }
    },
    mounted(){
      if(this.$store.watch.areExternalMeasuresLoaded === false)
        return;
      // init chart and set default
      this.chart = echarts.init(document.getElementById('graph'));
      if (this.type === 'vitals' || this.type === 'all'){
        if (this.checkedVitalsOnly)
          this.refreshGraph(this.graphOption)
      }
      else {
        if (this.checkedMeasuresOnly)
          this.refreshGraph(this.graphOption)
      }
      // if (this.checkedMeasures)
      //   this.refreshGraph(this.graphOption);
    },
    beforeDestroy() {
      delete this.checkedMeasDescs;
      delete this.graphOption;
      delete this.checkedMeasures;
      delete this.checkedMeasuresOnly
      delete this.checkedVitalsOnly
      delete this.allData;
      if(this.chart)
      {
        this.chart.dispose();
        delete this.chart;
      }
    },
    computed: {
      ...mapGetters('login/watch', {
        checkedMeasures: 'getCheckedMeasures',
        checkedMeasuresOnly: 'getCheckedMeasuresOnly',
        checkedVitalsOnly: 'getCheckedVitalsOnly'
      }),
      ...mapGetters('login', {
        allData: 'getAllData'
      }),
      // updateActualChecked() {
      //   let actualChecked = {}
      //   let vitalCodes = Object.values(this.allData.vitalSigns)
      //   Object.keys(this.checkedMeasures).forEach(measCcd => {
      //     if (this.type === 'vitals'){
      //       if (vitalCodes.includes(measCcd))
      //         actualChecked[measCcd] = true
      //     }
      //     if (this.type === 'watch'){
      //       if (!vitalCodes.includes(measCcd))
      //         actualChecked[measCcd] = true
      //     }
      //   })
      //   return actualChecked
      // },
      checkedMeasDescs() {
        if(!this.allData || !this.allData.ccds)
          return;
        let descs = [];
        if (this.type === 'vitals' || this.type === 'all'){
          Object.keys(this.checkedVitalsOnly).forEach(measCcd => {
            if (this.allData && this.allData.ccds) {
              descs.push(this.allData.ccds[measCcd] ? this.allData.ccds[measCcd].desc : '');
            }
          });
        }
        else {
          Object.keys(this.checkedMeasuresOnly).forEach(measCcd => {
            if (this.allData && this.allData.ccds) {
              descs.push(this.allData.ccds[measCcd] ? this.allData.ccds[measCcd].desc : '');
            }
          });
        }
        return descs;
      },
      graphOption() {
        // let xAxis = [];
        let xAxis = [{
            name: 'Date',
            type: 'time',
          }];
        // let yAxis = this.getY_echart();
        let yAxis = [];
        let series = [];

        const colors = ['#ff2d00', '#83ff00', '#f39c12 ', '000000'];
        const measCcds = (this.type === 'vitals' || this.type === 'all') ? Object.keys(this.checkedVitalsOnly) : Object.keys(this.checkedMeasuresOnly)
        const isSingleGraph = measCcds.length === 1;
        let weightAtIndex0 = 0, weightAtIndex1 = 0;

        /*** graphs more than 2 measurements
         measCcds.forEach((measCcd, index) => {
          xAxis.push(this.getX_echart(measCcd, index));
          if (yAxis.length < 2) {
            if (yAxis.length % 2 === 0) {
              yAxis.push(this.getY_echart(measCcd, index));
              series.push(this.getSeries_echart(measCcd, index+1, isSingleGraph));
            }
            else {
              yAxis.push(this.getY_echart(measCcd, index));
              series.push(this.getSeries_echart(measCcd, index+1, isSingleGraph));
            }
          }
         });
         ***/

        for (let i = 0; i < measCcds.length; i++) {
          // console.log(measCcds) array of ccds that are graphed

          // pulse = 77808 = weight 0
          // dpressure = 76633 = weight 1
          // spressure = 77371 = weight 2

          if (yAxis.length % 2 === 0 || yAxis.length === 3) {
            if (yAxis.length === 2 && measCcds.includes('76633') && measCcds.includes('77371')) {
              yAxis[2] = this.getY_echart(measCcds[2], i, ALIGNMENT.RIGHT)
              yAxis[2] = this.getSeries_echart(measCcds[2], i+1, isSingleGraph)
            }
            else {
              weightAtIndex0 = getMeasureWeightByCcd(measCcds[0], this.allData);

              yAxis[0] = this.getY_echart(measCcds[0], i, ALIGNMENT.LEFT);
              series[0] = this.getSeries_echart(measCcds[0], i + 1, isSingleGraph);
            }
          }
          // else insert into either [0] or [1], based on the weight
          else if (yAxis.length === 1){
            weightAtIndex1 = getMeasureWeightByCcd(measCcds[1], this.allData);

            // if both are pressures, should be same side of chart
            if (measCcds.includes('76633') && measCcds.includes('77371')){
              yAxis[1] = this.getY_echart(measCcds[1], i, ALIGNMENT.LEFT);
              series[1] = this.getSeries_echart(measCcds[1], i + 1, isSingleGraph, true);
              series[0].yAxisIndex = 0
              series[1].yAxisIndex = 0
            }

            // reorder, weight on the left should be less than weight on the right
            else if (weightAtIndex0 > weightAtIndex1) {
              yAxis[1] = this.getY_echart(measCcds[1], i, ALIGNMENT.RIGHT);
              series[1] = this.getSeries_echart(measCcds[1], i + 1, isSingleGraph);
            }
            else {
              yAxis[0] = this.getY_echart(measCcds[1], i, ALIGNMENT.LEFT);
              series[0] = this.getSeries_echart(measCcds[1], i+1, isSingleGraph);

              yAxis[1] = this.getY_echart(measCcds[0], 0, ALIGNMENT.RIGHT);
              series[1] = this.getSeries_echart(measCcds[0], 1, isSingleGraph);
            }
          }
          // console.log(yAxis)
        }

        return {
          color: colors,
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'cross'
            },
            enterable: true,
            // formatter: '{a}: <br/>{c} <button>GO</button>',
            formatter: '{a}: <br/>({c})'
          },
          // attributes on hover over
          legend: {
            data: this.checkedMeasDescs,
          },
          grid: {
            // left: '20%',
            // top: '20%',
            // right: '16%'
          },
          ...(((this.range && this.range.text == 'all') || this.type == 'watch' || this.type == 'all' || this.range == null) && { dataZoom: [
            {
              type: 'slider',
              xAxisIndex: 0,
              filterMode: 'none',
              start: 0,
              end: 100
            },
            // {
            //   type: 'slider',
            //   yAxisIndex: 0,
            //   filterMode: 'empty'
            // },
            {
              type: 'inside',
              xAxisIndex: 0,
              filterMode: 'empty'
            },
            {
              type: 'inside',
              yAxisIndex: 0,
              filterMode: 'empty'
            }
          ]}),
          toolbox: {
            show: false,
            orient: 'vertical',
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              dataView: {readOnly: false},
              magicType: {type: ['bar', 'line']},
              restore: {},
            }
          },
          xAxis: xAxis,
          yAxis: yAxis,
          series: series
        };

      }

    },
    watch: {
      'graphOption' (newOption) {
        this.refreshGraph(newOption);
      }
    },
    methods: {
      refreshGraph(option) {
        this.chart.clear();

        if (this.type === 'vitals' || this.type === 'all') {
          if (Object.keys(this.checkedVitalsOnly).length < 1) {
            option = this.emptyOption;
          }
        }
        else {
          if (Object.keys(this.checkedMeasuresOnly).length < 1) {
            option = this.emptyOption;
          }
        }
        this.chart.setOption(option);
      },

      /**
       * @param {Number} ccd measure ccd
       * @returns array of [{x,y}...]
       */
      getLineData_xy(ccd) {
        const measIds = (this.allData && this.allData.measCcdMeasIds && this.allData.measCcdMeasIds[ccd]) ? this.allData.measCcdMeasIds[ccd] : [];
        let data = [];
        // get dates
        measIds.forEach(measId => {
          data.push({
            x: (this.allData.measures[measId].lodate),
            y: (this.allData.measures[measId].value)
          });
        });
        return data;
      },
      /**
       * @param {Number} ccd measure ccd
       * @returns array of [[x,y]...]
       */
      getLineData(ccd) {
        const measIds = (this.allData && this.allData.measCcdMeasIds && this.allData.measCcdMeasIds[ccd]) ? this.allData.measCcdMeasIds[ccd] : [];
        let data = [];
        let listOfDates = []
        let today = Date.now();
        let _today = new Date(today);
        // get dates 
        if (!this.range){
          measIds.forEach(measId => {
            data.push(
              [
                this.allData.measures[measId].lotimestamp,
                this.allData.measures[measId].value
              ]
            );
            listOfDates.push(this.allData.measures[measId].lodate)
          });
        }
        else {
          // console.log(this.allData.measures)
          measIds.forEach(measId => {
            let measData = this.allData.measures[measId]
            let date2 = new Date(measData.lodate)
              // console.log(this.allData.measures[measId])
            if (today - date2.getTime() <= ((this.range - 1) * 86400000)) {
              data.push(
                [
                  measData.lotimestamp,
                  measData.value
                ]
              )
              listOfDates.push(measData.lodate)
            }
          })
        }
        listOfDates = listOfDates.sort()
        // console.log(listOfDates)
        while (this.getFullDate(_today) > listOfDates[0]){
          // console.log(this.getFullDate(today))
          if (!listOfDates.includes(this.getFullDate(_today))){
            // console.log(1)
            data.push(
              [
                this.getFullDate(_today),
                null
              ]
            )
          }
          today -= 86400000;
          _today = new Date(today)
        }

        // sort data by (x) lodate
        const comparator = (a,b) => {
          if (a[0] < b[0]) return -1;
          if (a[0] > b[0]) return 1;
          return 0;
        }
        data.sort(comparator);
        return data;
      },
      getFullDate(date){
        let answer = '' + date.getFullYear() + '-'
        if (date.getMonth() < 9)
          answer = answer + '0' + (date.getMonth()+1) + '-'
        else
          answer = answer + (date.getMonth()+1) + '-'
        if (date.getDate() <= 9)
          answer = answer + '0' + date.getDate()
        else
          answer = answer + date.getDate()
        return answer
      },
      getTitle(ccd) {
        return this.allData.ccds[ccd].desc;
      },
      getX(ccd) {
        const measIds = this.allData.measCcdMeasIds[ccd] ? this.allData.measCcdMeasIds[ccd] : [];
        let x = [];
        // get dates 
        measIds.forEach(measId => {
          x.push(this.allData.measures[measId].lodate);
        });
        return x;
      },
      getY(ccd) {
        const measIds = this.allData.measCcdMeasIds[ccd] ? this.allData.measCcdMeasIds[ccd] : [];
        let y = [];
        // get value of measures 
        measIds.forEach(measId => {
          y.push(this.allData.measures[measId].value);
        });
        return y;
      },
      getX_echart(ccd, index) {
        return {
          name: 'Date',
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          offset: index>0?(index-1)*25:0,
          // position: 'bottom',
          splitLine: {
              show: false
          },
          axisLine: {
              onZero: false,
              lineStyle: {
                
              }
          },
          data: this.getX(ccd)
        }
        
      },
      getY_echart(ccd, index, position) {
        // return [{
        //     type: 'value'
        //   }];
        return {
          name: getMeasureUnitByCcd(ccd, this.allData),
          // name: this.getUnitFromDescription(this.allData.ccds[ccd].desc),
          type: 'value',
          axisTick: {
            alignWithLabel: true
          },
          offset: index>0?(index-1)*50:0,
          position: position,
          splitLine: {
            show: false
          },
          axisLine: {
            // onZero: false,
            lineStyle: {
              // color: position === 'left' ? '#ff2d00' : '#83ff00',
            }
          },
          axisLabel : {
            overflow: 'allow',
            // formatter: '{value} °C'   // unit on the y-axis
          },
        };
      },
      getSeries_echart(ccd, index, isSingleGraph=true) {
        let series = {
          name: (this.allData.ccds && this.allData.ccds[ccd]) ? this.allData.ccds[ccd].desc : '',
          type: 'line',
          hoverAnimation: true,
          data: this.getLineData(ccd)
          
        };
        if (index === 1 && !isSingleGraph) {
          // series.xAxisIndex = index;
          series.yAxisIndex = index;
        }
        return series;
      },
    }
  }
  export const ALIGNMENT = {
    LEFT: 'left',
    RIGHT: 'right'
  }
</script>
